import script from "./TimeList.vue?vue&type=script&lang=ts&setup=true"
export * from "./TimeList.vue?vue&type=script&lang=ts&setup=true"

import "./TimeList.vue?vue&type=style&index=0&id=086c20bc&lang=css"

const __exports__ = script;

export default __exports__